import React from "react";
import styled from "styled-components";
import Button from "../../../components/Button";

const FlotaUI = styled.div`
  padding-top: 10vh;
  width: 100%;
  background-color: var(--black);

  color: var(--white);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  padding: 70px 40px;
`;

const FlotaCards = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 50px;
`;

const FlotaCard = styled.div`
  width: 300px;
  height: 300px;

  color: var(--black);
  border-radius: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
`;

const CardImg = styled.img`
  height: 50%;

  border-radius: 20px;
  transition: all 0.5s ease;
  @media (min-width: 1000px) {
    &:hover {
      transform: scale(1.1);
      z-index: 1;
      margin-bottom: 1rem;
      transition: all 0.5s ease;
    }
  }
`;

const CardName = styled.h2`
  font-size: 1.3rem;
  font-weight: 600;
  font-family: var(--roboto);
  color: var(--white);
`;

export const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 600;
  font-family: var(--raleway);
  color: var(--white);
  text-align: center;
  span {
    color: var(--red);
  }
  @media (max-width: 400px) {
    font-size: 2.2rem;
  }
`;

const Flota = () => {
  return (
    <>
      <FlotaUI>
        <Title>
          NUESTRA <span>FLOTA</span>
        </Title>
        <FlotaCards data-aos="fade-up" data-aos-delay="200">
          <FlotaCard>
            <CardImg src="/images/home/whitecr3.png" />
            <CardName>Fiat Cronos</CardName>
          </FlotaCard>
          <FlotaCard>
            <CardImg src="/images/home/corolla.png" />
            <CardName>Toyota Corolla</CardName>
          </FlotaCard>
          <FlotaCard>
            <CardImg src="/images/home/spin.png" />
            <CardName>Chevrolet Spin</CardName>
          </FlotaCard>
        </FlotaCards>
        <Button
          path="/flota"
          text="Ver flota"
          data-aos="fade-right"
          data-aos-delay="200"
        ></Button>
      </FlotaUI>
    </>
  );
};

export default Flota;
